export default __webpack_public_path__ + "static/media/Stovetop-Espresso-Maker.276b9c60.png";